import { formatEntityName, replaceEntityName, toastError, toastSuccess } from "helpers";
import React, { PropsWithChildren, useMemo } from "react";

import { useTranslations } from "../index";
import { ToastsContext, ToastsContextProps } from "./ToastsContext";

export const ToastsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const i18n = useTranslations();

  const value = useMemo<ToastsContextProps>(
    () => ({
      success: (message) => {
        return toastSuccess(message);
      },
      error: (message, err) => {
        return toastError(message, err);
      },
      addFailure: (entity, title, err) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const message = replaceEntityName(i18n.Entity_Add_Failure, entity);
        return toastError(message, err);
      },
      addSuccess: (entity, title) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const message = replaceEntityName(i18n.Entity_Add_Success, entity);
        return toastSuccess(message);
      },
      updateFailure: (entity, title, err) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const message = replaceEntityName(i18n.Entity_Update_Failure, entity);
        return toastError(message, err);
      },
      updateSuccess: (entity, title) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Update_Success, entity);
        return toastSuccess(newVariable);
      },
      deleteFailure: (entity, title, err) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Delete_Failure, entity);
        return toastError(newVariable, err);
      },
      deleteSuccess: (entity, title) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Delete_Success, entity);
        return toastSuccess(newVariable);
      },
      refreshSuccess: (entity, title) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Refresh_Success, entity);
        return toastSuccess(newVariable);
      },
      refreshFailure: (entity, title, err) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Refresh_Failure, entity);
        return toastError(newVariable, err);
      },
      saveSuccess: (entity, title) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Save_Success, entity);
        return toastSuccess(newVariable);
      },
      saveFailure: (entity, title, err) => {
        entity = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        const newVariable = replaceEntityName(i18n.Entity_Save_Failure, entity);
        return toastError(newVariable, err);
      },
    }),
    [i18n]
  );

  return <ToastsContext.Provider value={value}>{children}</ToastsContext.Provider>;
};
